import { config } from "~/lib/config"

// Not in `hubspot.client.ts`: `Layout` calls this during the SPA prerender,
// where `.client` modules are stubbed out.
export const hubspotTrackingSrc = (): string | null =>
  config.env.hubspotPortalId
    ? `https://js.hs-scripts.com/${config.env.hubspotPortalId}.js`
    : null
